export const MACHINE_TYPE = {
  ULTRAPRO: "ULTRAPRO",
  ULTIMATE: "ULTIMATE",
  ULTRA: "ULTRA",
  VANILA: "VANILA", //average = vanila
};
